import React from 'react';
import moment from 'moment';

import './RouteSchema.css';

import SchemaItem from '../RouteSchemaItem/RouteSchemaItem';

const RouteSchema = ({ routes, landingTime, distance, duration, waiting }) => {
  let startPoint = routes[0];
  let endPoint = routes[routes.length - 1];
  return (
    <div className="wrapper">
      <div className="routeSchema">
        <div className="startTime">
          {landingTime ? moment(landingTime).format('HH:mm') : null}
        </div>
        <div className="schemaList">
          <ul className="list">
            {routes.length &&
              routes.map((route, i) => (
                <SchemaItem
                  key={i}
                  number={i}
                  routes={routes}
                  first={startPoint}
                  last={endPoint}
                  waiting={route.duration}
                  address={route.route}
                  distance={distance}
                  duration={duration}
                />
              ))}
          </ul>
        </div>
      </div>
      <div className="routeInfo">
        <div className="infoField">
          <span className="key">Расчетное время в пути: </span>
          <span className="value">{duration}</span>
        </div>
        {waiting ? (
          <div className="infoField">
            <span className="key">Время ожидания: </span>
            <span className="value">3 ч 38 мин</span>
          </div>
        ) : null}
        <div className="infoField">
          <span className="key">Длина маршрута: </span>
          <span className="value">{distance}</span>
        </div>
      </div>
    </div>
  );
};

export default RouteSchema;
